import React from "react";
import { BasePageModal } from "@/shared/components/modal/page-modal/base-page-modal";
import { AggregateTypeElementField } from "@/features/accounts/ocr/components/aggregate-type-element-field";

interface Props {
  onTapCompleteModal: () => void;
  onTapFileAggregate: () => void;
  onTapCameraAggregate: () => void;
}

// OCR取込タイプ選択モーダル
export const SelectAggregateTypeModal= ({ onTapCompleteModal, onTapFileAggregate, onTapCameraAggregate }: Props) => {
  return (
    <BasePageModal
      title="明細を取り込む"
      handleClose={() => {
        onTapCompleteModal();
      }}
      className="md-new-ocr-select"
    >
      <h2>引き続きWeb明細帳に明細を取り込む</h2>
      <ul>
        <AggregateTypeElementField
          title="ファイルを選択して取り込み"
          className="btn-folder"
          handleClick={() => {
            onTapFileAggregate();
          }}
        />
        <AggregateTypeElementField
          title="写真を撮影して取り込み"
          className="btn-camera"
          handleClick={() => {
            onTapCameraAggregate();
          }}
        />
      </ul>
    </BasePageModal>
  )};
